import React from 'react';
import Home from './components/Home';
import Payment from './components/Payment';
import Committee from './components/Committee';
import OurStory from './components/OurStory';
import NewsEvents from './components/NewsEvents';
import PhotoAlbum from './components/PhotoAlbum';
import Memorial from './components/Memorial';

const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
    {
        path: '/committee',
        element: <Committee />
    },
    {
        path: '/Payment', // Add Payment route
        element: <Payment />
    },
    {
        path: '/News',
        element: <NewsEvents /> // Add this route
    },
    {
        path: '/Our-Story', // Add the route for OurStory
        element: <OurStory />
    },
    {
        path: '/photo-album', // Add the route for PhotoAlbum
        element: <PhotoAlbum />
    },
    {
        path: '/memorial', // Add the route for PhotoAlbum
        element: <Memorial />
    },
];

export default AppRoutes;
